function Zypher() {
  return (
    <div className="portfolio-zypher">
      <div className="portfolio-description">
        <p>
          A book rental{" "}
          <a
            href="https://play.google.com/store/apps/details?id=co.zypher.connect"
            target="_blank"
            rel="noreferrer noopener"
            style={{ color: "#00f0b7eb" }}
          >
            app
          </a>
          .
        </p>
        <p>Worked as an intern while in college.</p>
        <p>Worked on creating backend API.</p>
        <p>Using Node.js + Express + MongoDB</p>
      </div>
    </div>
  );
}

export default Zypher;
